import React from 'react'
import { Platform, Pressable } from 'react-native'
import { useTranslation } from 'react-i18next'
import { router } from 'expo-router'

import TileBlur from '@ui/tiles/TileBlur'
import Button from '@ui/buttons/Button'
import useAnimatedPress from '@ui/animated/useAnimatedPress'
import { useStaffLoginCustomer } from 'hooks/useStaffLoginCustomer'
import StaffCustomerLoginModal from '@user/StaffCustomerLoginModal'

export default function QuickLoginSection() {
  const { animation, onPressIn, onPressOut } = useAnimatedPress()
  const { t } = useTranslation(['staff'])
  const text = 'staff:panel.sections.quickLogin'

  const verify = useStaffLoginCustomer()

  const onPress = () => {
    router.navigate('/staff/quick-login')
  }

  return (
    <>
      <Pressable
        onPress={onPress}
        onPressIn={onPressIn}
        onPressOut={onPressOut}
        className="flex-1"
      >
        <TileBlur
          variant="small"
          title={t(`${text}.title`)}
          desc={t(`${text}.desc`)}
          cta={
            <Button
              noninteractive
              animation={animation}
              onPress={onPress}
              size="sm"
              variant="outlined"
              label={t(`${text}.cta`)}
            />
          }
          glassProps={{
            animation,
            image: require('@/images/rocket.png'),
            imageWrapperStyle: {
              transform: [{ rotate: '45deg' }],
            },
            imageStyle: {
              transform: [
                { translateX: Platform.select({ default: 60, web: 25 }) },
                { translateY: Platform.select({ default: -20, web: -50 }) },
              ],
            },
            blurStyle: {
              opacity: 0.66,
              transform: [
                { rotate: '45deg' },
                { translateX: 200 },
                { translateY: 0 },
                { scale: 1.75 },
              ],
            },
          }}
          classNameDesc="pr-16"
        />
      </Pressable>
      <StaffCustomerLoginModal
        onSuccess={() => {
          verify.cancel()
        }}
        auto
        verify={verify}
      />
    </>
  )
}
